import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=23ff9b9d&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=23ff9b9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff9b9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ff9b9d')) {
      api.createRecord('23ff9b9d', component.options)
    } else {
      api.reload('23ff9b9d', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=23ff9b9d&scoped=true&", function () {
      api.rerender('23ff9b9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V96e0qqhf1v3/JS/comp/Voucher.vue"
export default component.exports